import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@examdojo/core/environment';
import { ExamdojoSupabaseService, TableRowModel } from '@examdojo/supabase';
import { from, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImageChatMessageHttpService {
  constructor(
    private readonly http: HttpClient,
    private readonly supabase: ExamdojoSupabaseService,
  ) {}

  private readonly baseUrl = `${environment.examdojo.examdojoApiUrl}/review/content-chat`;

  fetchAllByChatIdAndMetadata(
    llmChatId: number,
    stemId: number,
  ): Observable<Array<TableRowModel<'llm_chat_messages'>>> {
    return from(
      this.supabase.client
        .from('llm_chat_messages')
        .select()
        .eq('llm_chat_id', llmChatId)
        .eq('metadata ->> stem_id', String(stemId))
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  fetchMessageByIds(messageIds: number[]): Observable<Array<TableRowModel<'llm_chat_messages'>>> {
    return from(
      this.supabase.client
        .from('llm_chat_messages')
        .select()
        .in('id', messageIds)
        .or('metadata ->> auto_generated.is.null,metadata ->> auto_generated.eq.false')
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  fetchMessageByChatIds(chatIds: number[]): Observable<Array<TableRowModel<'llm_chat_messages'>>> {
    return from(
      this.supabase.client
        .from('llm_chat_messages')
        .select()
        .in('llm_chat_id', chatIds)
        .or('metadata ->> auto_generated.is.null,metadata ->> auto_generated.eq.false')
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  fetchMessagesByRequestId(requestId: string, chatId: number): Observable<Array<TableRowModel<'llm_chat_messages'>>> {
    return from(
      this.supabase.client
        .from('llm_chat_messages')
        .select()
        .eq('created_by_role', 'ai')
        .eq('llm_chat_id', chatId)
        .eq('metadata ->> request_id', requestId)
        .or('metadata ->> auto_generated.is.null,metadata ->> auto_generated.eq.false')
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  sendMessage(message: string, chatId: number) {
    return this.http.post<{ request_id: string }>(`${this.baseUrl}/${chatId}/messages`, {
      message,
    });
  }
}
